export const NegativeFulfilmentStatus = [
  'ORDER_UNDELIVERABLE',
  'ORDER_CANCELLED',
  'ORDER_RETURNED',
  'PICKUP_EXCEPTION',
  'ORDER_FAILED'

];